import { render, staticRenderFns } from "./ledgerRolePhone.vue?vue&type=template&id=318ec9a9&scoped=true&"
import script from "./ledgerRolePhone.vue?vue&type=script&lang=js&"
export * from "./ledgerRolePhone.vue?vue&type=script&lang=js&"
import style0 from "./ledgerRolePhone.vue?vue&type=style&index=0&id=318ec9a9&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ec9a9",
  null
  
)

export default component.exports